// todo добавить свойства при необходимости
export const partsProperties = {
    brackets: {},
    edge: {},
    locker: {},
    punchPanel: {},
    railing: {
        vertical: {
            width: 2,
            doubleWidth: 4,
        }
    },
    shelf: {}
}
